import {
  FETCH_USER,
  FETCH_USERS,
  NEAREST_DRIVERS,
  CALCULATE_DISTANCE,
  GET_ORDER_RIDE,
  SET_COORDINATE_START,
  SET_ID_ORDERED_RIDE,
  SET_STATUS_ORDERED_RIDE,
  DEL_STATUS_ORDERED_RIDE,
  DEL_ID_ORDERED_RIDE,
  FETCH_USER_BY_ROLE,
  MAP_LOCATIONS,
} from "../../Constants/actionTypes";

export interface UserState {
  dataUsers: any[];
  dataUser: Record<string, any>;
  dataMapLocations: any;
  dataNearestDrivers: any;
  dataCalculateDistance: any;
  dataOrderRide: any;
  dataCoordinatStart: any[];
  dataIdOrderedRide: any;
  dataStatusOrderedRide: any;
  dataUsersByRole: any;
}

const initialState: UserState = {
  dataUsers: [],
  dataUser: {},
  dataMapLocations: null,
  dataNearestDrivers: null,
  dataCalculateDistance: null,
  dataOrderRide: null,
  dataCoordinatStart: [],
  dataIdOrderedRide: null,
  dataStatusOrderedRide: null,
  dataUsersByRole: null,
};

const userReducer = (state = initialState, action: any): UserState => {
  switch (action.type) {
    case MAP_LOCATIONS:
      return { ...state, dataMapLocations: action.payload };
    case NEAREST_DRIVERS:
      return { ...state, dataNearestDrivers: action.payload };
    case CALCULATE_DISTANCE:
      return { ...state, dataCalculateDistance: action.payload };
    case GET_ORDER_RIDE:
      return { ...state, dataOrderRide: action.payload };
    case SET_COORDINATE_START:
      return { ...state, dataCoordinatStart: action.payload };
    case SET_ID_ORDERED_RIDE:
      return { ...state, dataIdOrderedRide: action.payload };
    case DEL_ID_ORDERED_RIDE:
      return { ...state, dataIdOrderedRide: null };
    case SET_STATUS_ORDERED_RIDE:
      return { ...state, dataStatusOrderedRide: action.payload };
    case DEL_STATUS_ORDERED_RIDE:
      return { ...state, dataStatusOrderedRide: null };
    case FETCH_USERS:
      return { ...state, dataUsers: action.payload };
    case FETCH_USER_BY_ROLE:
      return { ...state, dataUsersByRole: action.payload };
    case FETCH_USER:
      return { ...state, dataUser: action.payload };
    default:
      return state;
  }
};

export default userReducer;
